document.querySelectorAll('.insights-list[data-insights]').forEach((list) => {
  let page = 1;
  const perPage = 12;
  const container = list.querySelector('.cards-grid__container');
  let items = list.querySelectorAll('.insight-card');
  const loadMoreButton = list.querySelector('.insights-list__load-more-button');

  if (items.length < perPage) {
    loadMoreButton.style.display = 'none';
  }

  loadMoreButton.addEventListener('click', () => {
    page++;

    loadMoreButton.disabled = true;

    fetch(`${ajaxurl}?action=get_insights&page=${page}`)
      .then((response) => response.json())
      .then((data) => {
        container.innerHTML += data.data;

        items = list.querySelectorAll('.insight-card');

        if (items.length < perPage * page) {
          loadMoreButton.style.display = 'none';
        } else {
          loadMoreButton.disabled = false;
        }
      });
  });
});